<!--
MENSAGENS DE VALIDACAO DE CAMPOS
-->


<template>
    <div class="row mb-2">
        <div class="col-md-12 col-12">
            <div class="nb-validation">
                <!-- <strong class="title"> {{ title }} </strong> -->
                <div class="nb-validation-message message-error" role="alert" v-for="(err, index) in messages" :key="index">
                    <span>{{ err }}</span>
                </div>
                <div v-if="showcontinueanyway && messages && messages.length > 0" class="float-right">
                  <v-button label="Salvar mesmo com errors de validação" icon="" @click="handleContinueAnyWay()"
                    title="Salvar mesmo com errors de validação"></v-button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'alert',

    props: {
      title: { type: String },
      messages: { type: Array },
      showcontinueanyway: { type: Boolean, default: false },
    },

    data () {
        return {
            show: true,
        }
    },

    watch: {
      messages: function() {
       return this.messages
      }
    },

    methods: {
        handleContinueAnyWay(){
          console.log('handlecontinueanyway')
          this.$emit('continueanyway');
        },
        toggleAlert() {
            this.show = false
        }
    },

   mounted(){
   },

   created(){

   },

}
</script>

<style scoped>

.nb-validation {
    box-sizing: border-box;
    /* background-color: rgba(53, 52, 100, 0.055); */
    /* border: 1px solid #C9D3DD; */
    /* border: 1px solid #F9B3C1; */
    height: 100%;
    position: relative;
    margin: 0;
    /* padding: 20px; */
}

.nb-validation-message {
    border-radius: 0 3px 3px 0;
    border: 1px solid;
    border-left: 3px solid;
    padding: 3px;
    padding-left: 10px;
    margin: 3px;
    position: relative;
}

.nb-validation-message.message-error {
    /* color: #b98e00; */
    color: #BC1132;
    border-top: 1px solid #F9B3C1;
    border-bottom: 1px solid #F9B3C1;
    border-left: 3px solid #F43E61;
    border-right: 1px solid #F9B3C1;
    /* border-color: #ffdf79 #ffdf79 #ffdf79 #ffc200; */
    background: #fff4ce;
}

.nb-validation.title {
    display: block;
    font-size: 14px;
    font-weight: 700;
}

</style>



// WEBPACK FOOTER //
// src/components/validation.vue